import { Injectable } from "@angular/core";
import { ApiService } from "@bt/core";
import { RegistrationModel } from "./registration.models";
import { Observable } from "rxjs";
import { IResponse, ConfirmationSessionDto } from "@bt/shared";

@Injectable()
export class RegistrationService {
  constructor(private api: ApiService) { }

  public register(model: RegistrationModel): Observable<IResponse<ConfirmationSessionDto>> {
    return this.api.postAnonym<ConfirmationSessionDto>("api/users", {
      email: model.email,
      password: model.password,
      passwordConfirmation: model.passwordConfirmation
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/public/registration/registration.service.ts